import {t} from "@lingui/core/macro";
import * as React from "react";

import type {Author} from "#content-library/types/types.ts";

import strings from "../strings.tsx";

type Props = {
    authorList: Array<Author>;
};

class AuthorList extends React.Component<Props> {
    render(): React.ReactNode {
        const {authorList} = this.props;

        if (!authorList.length) {
            return null;
        }

        // Build a comma-separated lists of links with the authors' names,
        // pointing to their profiles.
        //
        // Examples
        //   Created by [Sal Khan]
        //   Created by [Sal Khan] and [Sarah Singer]
        //   Created by [Sal Khan], [Sarah Singer], and [Joe Singer]
        const nameList: Array<any> = [];
        authorList.forEach((author, i) => {
            // Prefix separator between names
            if (i > 0) {
                if (i === authorList.length - 1) {
                    if (authorList.length > 2) {
                        nameList.push(
                            t({
                                context:
                                    "Oxford comma for the win!Separator between the last two items in a list",
                                message: ", and ",
                            }),
                        );
                    } else {
                        nameList.push(
                            t({
                                context:
                                    "Separator between the items in a two-item list",
                                message: " and ",
                            }),
                        );
                    }
                } else {
                    nameList.push(
                        t({
                            context: "Separator between items in a list",
                            message: ", ",
                        }),
                    );
                }
            }

            nameList.push(author.name);
        });

        // Some languages can have different translations
        // for single and multiple authors
        if (nameList.length === 1) {
            const name = nameList[0];
            return <span>{strings.createdBy(name)}</span>;
        }

        return <span>{strings.createdByMany(nameList)}</span>;
    }
}

export default AuthorList;
